module.exports = __webpack_public_path__ + "static/media/uspolo2.f78560b3.jpg";